module.exports = __webpack_public_path__ + "fonts/ui-icon.42e0fb7.woff";